export default {
  header:{
    title: 'Your Order',
    btnMap: {
      show:'Show Map',
      hide:'Hide Map',
    },
  },
  seat: '{{seat}} Seat',
  seats: '{{seats}} Seats',
  total: 'Total',
  btnPayment: {
    precced: 'Book',
    pay: 'Confirm Payment',
  },
  dropoffTime: '(Dropoff Time)',
};